/* global document, localStorage */
import $ from 'jquery';
import querySelectors from '../utils/querySelectors';

const cookiesNotice = (selectors, uiSettings) => {

    let $$ = [];
    let classes = {};

    const construct = () => {
        $$ = querySelectors(Object.assign({
            button: '',
            container: ''
        }, selectors));
        classes = Object.assign({
            accepted: '',
            hidden: ''
        }, uiSettings);
    };

    const bindEvents = function () {
        $$.button.on('click', () => {
            $$.container.addClass(classes.accepted);
            localStorage.setItem('cookies-accepted', true);
        });
    };

    const run = function () {
        bindEvents();
        if (localStorage.getItem('cookies-accepted')) {
            return;
        }
        $$.container.removeClass(classes.hidden);
    };

    construct();

    return {
        run
    }

};

export default cookiesNotice;


// WEBPACK FOOTER //
// ./src/js/modules/cookieNotice.js